import { ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { NavigationHistoryContext } from "context/navigationHistoryContext";
import { useContext } from "react";
import { To } from "react-router-dom";

type BackPageButtonProps = {
  text: string;
  link: To;
};
const BackPageButton = ({ text, link }: BackPageButtonProps) => {
  const { backNavigate } = useContext(NavigationHistoryContext);

  return (
    <Button
      onClick={() => backNavigate({ reserveLocation: link })}
      startIcon={<ArrowBack />}
      sx={{ mb: 1.5, p: 0, justifyContent: "flex-start", color: "base.200" }}>
      {text}
    </Button>
  );
};

export default BackPageButton;
